import { Command } from 'lucide-react';
import { cn } from '@/lib/utils';
import { isMacPlatform } from '@/utils/platform';

/**
 * Kbd - Keyboard key chip matching the app's existing hint styling
 * (see CommandPalette footer and FormFillPage shortcuts help).
 */
export function Kbd({ children, className }) {
  return (
    <kbd
      className={cn(
        'inline-flex items-center gap-1 rounded-control border border-line bg-surface-2 px-1.5 py-0.5 text-caption font-mono text-ink-2',
        className
      )}
    >
      {children}
    </kbd>
  );
}

/**
 * ModKey - The platform's primary shortcut modifier:
 * the ⌘ icon on Apple platforms, "Ctrl" everywhere else.
 */
export function ModKey({ className }) {
  if (isMacPlatform()) {
    return <Command className={cn('size-3', className)} aria-label="Command" />;
  }
  return <span className={className}>Ctrl</span>;
}

/**
 * ShortcutHint - A single key chip showing the platform modifier plus a key,
 * e.g. [⌘ ↵] on Mac or [Ctrl ↵] on Windows/Linux.
 *
 * @param {Object} props
 * @param {string} props.keyLabel - The non-modifier key (e.g. "K", "S", "↵")
 * @param {string} [props.className] - Extra classes for the chip
 */
export function ShortcutHint({ keyLabel, className }) {
  return (
    <Kbd className={className}>
      <ModKey />
      <span>{keyLabel}</span>
    </Kbd>
  );
}
